import { Component, OnInit, input, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorMessageService } from '@app/shared/services/material-error-message.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'material-form-text-area',
    templateUrl: './form-text-area.component.html',
    styleUrls: ['./form-text-area.component.scss'],
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule]
})

export class FormTextAreaComponent implements OnInit {
  private errorMessageService = inject(ErrorMessageService);

  readonly title = input<string>(undefined);
  readonly control = input<FormControl>(undefined);

  ngOnInit() {
  }

  getError() {
    return this.errorMessageService.getErrorMessageUsingFormControl(this.control());
  }
}
